/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-boolean-value */
// eslint-disable-next-line react/no-array-index-key
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import { Fade } from 'react-awesome-reveal';
import { Swiper, SwiperSlide } from 'swiper/react';
import {
  Navigation, Pagination, Scrollbar, A11y, Autoplay,
} from 'swiper/modules';

import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function Testimonial({ data }) {
  return (
    <section id="partner" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <Fade direction="up" triggerOnce>
          <div className="text-center mb-12">
            <p className="text-sm font-medium text-theme-purple uppercase tracking-wider mb-3">
              Partner Testimonials
            </p>
            <h2 className="text-4xl md:text-5xl text-theme-blue font-bold mb-4">
              Trusted by Industry Leaders
            </h2>
            <p className="text-lg text-gray-500 max-w-2xl mx-auto">
              Hear from our partners about their experience working with us
            </p>
          </div>
        </Fade>

        <Fade direction="up" delay={200} triggerOnce>
          <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
            className="testimonial-swiper"
            loop={true}
            navigation={true}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            slidesPerView={1}
            spaceBetween={24}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {data.map((item) => (
              <SwiperSlide key={item.id}>
                <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 h-full flex flex-col cursor-pointer hover:shadow-xl hover:border-theme-purple/20 transition-all duration-300">
                  {/* Quote icon */}
                  <div className="mb-6">
                    <svg className="w-10 h-10 text-theme-purple/20" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                    </svg>
                  </div>

                  {/* Testimonial text */}
                  <p className="text-gray-600 text-lg leading-relaxed mb-8 flex-grow">
                    &ldquo;{item.testimoni}&rdquo;
                  </p>

                  {/* Author info */}
                  <div className="flex items-center mt-auto pt-6 border-t border-gray-100">
                    <img
                      src={item.imageUrl}
                      alt={item.name}
                      className="w-14 h-14 rounded-full object-cover border-2 border-theme-purple/20"
                    />
                    <div className="ml-4">
                      <h4 className="text-theme-blue font-semibold">{item.name}</h4>
                      <p className="text-gray-500 text-sm">{item.company}</p>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Fade>
      </div>
    </section>
  );
}
